// 地图坐标转换工具函数

/**
 * 百度地图坐标转换为高德地图坐标
 * @param {number} lng 百度地图经度
 * @param {number} lat 百度地图纬度
 * @returns {object} 高德地图坐标 {lng, lat}
 */
export function baiduToAmap(lng, lat) {
  const x_pi = 3.14159265358979324 * 3000.0 / 180.0;
  const x = lng - 0.0065;
  const y = lat - 0.006;
  const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
  const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
  const amapLng = z * Math.cos(theta);
  const amapLat = z * Math.sin(theta);
  return {
    lng: lng,
    lat: lat
  };
}

/**
 * 高德地图坐标转换为百度地图坐标
 * @param {number} lng 高德地图经度
 * @param {number} lat 高德地图纬度
 * @returns {object} 百度地图坐标 {lng, lat}
 */
export function amapToBaidu(lng, lat) {
  const x_pi = 3.14159265358979324 * 3000.0 / 180.0;
  const z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_pi);
  const theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_pi);
  const baiduLng = z * Math.cos(theta) + 0.0065;
  const baiduLat = z * Math.sin(theta) + 0.006;
  return {
    lng: lng,
    lat: lat
  };
}

/**
 * 批量转换百度地图坐标点为高德地图坐标
 * @param {Array} points 百度地图坐标点数组 [{lng, lat}, ...]
 * @returns {Array} 高德地图坐标点数组
 */
export function batchBaiduToAmap(points) {
  return points.map(point => baiduToAmap(point.lng || point.lon, point.lat));
}


// WEBPACK FOOTER //
// ./src/common/mapUtils.js